<template>
    <div class="shop col-md-6">
        <b-card show-header class="mb-4" show-footer>
            <h3 slot="header">{{ shop.name | translate }}</h3>
            <div class="row">
                <div class="col-xs-12 col-md-4">
                    <div class="icon btn" @click="produce({shop})"
                         :id="'produce-' + shop.id"
                         :class="{'disabled': (shop.amount < 1 || shop.disableProduceButton === true || shop.isProducing === true )}">
                        <i class="fa shop-font-icon" :class="shop.faClass"></i>
                    </div>
                    <b-popover triggers="[]" show placement="top" :title="step.title" :target="'produce-' + shop.id" v-if="(shop.id === 'LemonadeStand' && (step.id === 3 || step.id === 5 || step.id === 11) || (shop.id === 'PaperDelivery' && step.id === 7))">
                        {{ step.text }}
                    </b-popover>
                    <div class="amount badge-outer center label-info" @click="play">
                        <div class="badge-inner">
                            <span>{{ shop.amount }}</span>
                        </div>
                    </div>
                </div>
                <div class="col-xs-12 col-md-8">
                    <div class="progress">
                        <div class="progress-bar progress-bar-success"
                             :class="{'progress-bar-striped progress-bar-animated active': !shop.doProgressUpdates}"
                             role="progressbar"
                             aria-valuenow="0"
                             aria-valuemin="0"
                             aria-valuemax="100"
                             :style="{ 'width': (shop.doProgressUpdates ? progress.progress : 100) + '%' }">
                            <span class="earnings">{{ shop.earnings | NiceAmount }}</span>
                        </div>
                    </div>
                    <div class="meta row mb-1">
                        <div class="earnings-per-seconds col-md-8" v-if="shop.hasManager === true && shop.showEarningPerSecond === true">
                            <!--@todo: use method/computed-->
                            <span class="shop-meta">
                                {{ (Math.floor((shop.earnings / shop.coolDown) * 100) / 100 ) | NiceAmount }} /s
                            </span>
                        </div>
                        <div class="time col align-self-end">
                            <b-badge variant="primary" class="shop-meta">{{ progress.remaining | FormatTime }}</b-badge>
                        </div>
                    </div>
                </div>
            </div>
            <button slot="footer"
                    :id="'buy-' + shop.id"
                    class="shop-info btn btn-primary"
                    :class="{'disabled': !shop.isAffordable()}"
                    @click="buildBranches({ shop, amount: shop.maxAmount })">
                {{ $t('BUYXFOR', { amount: shop.maxAmount, price: tl(shop.costs) }) }}
            </button>
            <b-popover show placement="top" :title="step.title" :target="'buy-' + shop.id" v-if="(shop.id === 'LemonadeStand' && (step.id === 2 || step.id === 4)) || (shop.id === 'PaperDelivery' && step.id === 6)">
                {{ step.text }}
            </b-popover>
        </b-card>
    </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import NiceAmount from '../filters/NiceAmount';
export default {
    name:     'shop',
    props:    ['shop', 'progress'],
    computed: mapGetters({
        step: 'step'
    }),
    methods:  {
        ...mapActions([
            'buildBranches',
            'produce',
            'incrementAmount',
            'setStep'
        ]),
        tl(val) {
            return NiceAmount(val);
        },
        play() {
            this.$playSound('s11');
        },
        nextStep() {
            if (this.step.id === 8) {
                this.setStep(9);
            } else if (this.step.id === 1) {
                this.setStep(2);
            } else if (this.step.id === 2) {
                this.setStep(3);
            } else if (this.step.id === 4) {
                this.setStep(5);
            }
        }
    }
};
</script>

<style scoped lang="less">
.panel .icon i {
    display: flex;
    justify-content: center;
    align-items: center;
}
i.upgrade-font-icon, i.shop-font-icon, i.achievement-font-icon {
    color: #b31243;
}
.shop {
    .icon {
        position: relative;
        text-align: center;
        margin: 0 auto;
        width: 100%;
        &.btn {
            cursor: pointer;
        }
        &.btn.disabled {
            cursor: default;
        }
    }
    .progress {
        overflow: hidden;
        height: 50px;
        position: relative;
        margin-bottom: 18px;
        background-color: #f5f5f5;
        border-radius: 4px;
        -webkit-box-shadow: inset 0 1px 2px rgba(0, 0, 0, 0.1);
        box-shadow: inset 0 1px 2px rgba(0, 0, 0, 0.1);

        .earnings {
            position: absolute;
            width: 100%;
            left: 0;
            text-align: center;
        }
    }
    .progress-bar {
        /* -webkit-transition: none; */
        transition-delay: 10ms;
        transition-duration: 150ms;
        line-height: 50px;
        font-size: 1.5em;
        color: #000;
        width: 0;
        height: 100%;
        text-align: center;
        background-color: #f68b25;
        -webkit-box-shadow: inset 0 -1px 0 rgba(0, 0, 0, 0.15);
        box-shadow: inset 0 -1px 0 rgba(0, 0, 0, 0.15);
        -webkit-transition: width 0.6s ease;
        -o-transition: width 0.6s ease;
        transition: width 0.6s ease;
    }
    .badge-outer {
        position: relative;
        top: -0.75em;
        font-size: 1.1rem;
        padding: 5px;
        border-radius: 4px;
        width: 100%;
        opacity: 1;
        color: #ffffff;
        background: #ffffff;
        -webkit-box-shadow: 0 0 5px 1px rgba(106, 106, 106, 0.1);
        box-shadow: 0 0 5px 1px rgba(106, 106, 106, 0.1);
        border: 1px solid #ddd;

        .badge-inner, .badge {
            background: #5cbcf6;
            text-align: center;
        }
    }
}
</style>
